import Reveal from '@/components/base/Reveal';
import { synopsisLead, synopsisPoints } from '@/mocks/content';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function StorySection() {
  return (
    <section id="story" className="scroll-mt-16 bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <SectionHeading
                eyebrow="Story"
                title="故事背景与常见脉络"
                desc="这里整理的是这一类作品普遍呈现的故事框架与阅读方向，帮助你快速建立整体印象，而不涉及具体情节的判断。"
              />
            </Reveal>

            <Reveal delay={80}>
              <div className="mt-8 rounded-lg bg-background-100 border border-background-200 p-5 md:p-6">
                <p className="text-sm md:text-base leading-relaxed text-foreground-700">{synopsisLead}</p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {synopsisPoints.map((point, index) => (
                <Reveal key={point.title} delay={index * 60}>
                  <article className="h-full rounded-lg bg-background-50 border border-background-200 p-5 flex flex-col gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 text-xl">
                      <i className={point.icon} />
                    </span>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900">
                      {point.title}
                    </h3>
                    <p className="text-sm leading-relaxed text-foreground-600">{point.desc}</p>
                  </article>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}